module.exports = __webpack_public_path__ + "static/media/face2ok.175fd90b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Components/FeedbackForm/images/face2ok.svg
// module id = 1217
// module chunks = 2